import { render, staticRenderFns } from "./FooterECI.vue?vue&type=template&id=4bb23e3b&scoped=true&"
import script from "./FooterECI.vue?vue&type=script&lang=js&"
export * from "./FooterECI.vue?vue&type=script&lang=js&"
import style0 from "./FooterECI.vue?vue&type=style&index=0&id=4bb23e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb23e3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VImg,VRow})
